import dayjs, { Dayjs } from "dayjs";

type HasDayjsTimestamps<T> = {
  [K in keyof T]: K extends `${string}_at` ? Dayjs : T[K];
};

type HasStringTimestamps<T> = {
  [K in keyof T]: K extends `${string}_at` ? string : T[K];
};

export const DateHelper = {
  convertStringToDayjs<T extends HasStringTimestamps<T>>(obj: T) {
    const newObj = {} as HasDayjsTimestamps<T>;

    const keys = Object.keys(obj) as (keyof T)[];

    keys.forEach((key) => {
      const v = obj[key];

      if (
        typeof key === "string" &&
        typeof v === "string" &&
        key.endsWith("_at")
      ) {
        newObj[key] = dayjs(v) as T[keyof T];
      } else {
        newObj[key] = v;
      }
    });

    return newObj;
  },
  convertDayjsToString<T extends HasDayjsTimestamps<T>>(
    obj: T,
    fn: (d: Dayjs) => unknown = (d) => d.toISOString()
  ) {
    const newObj = {} as HasStringTimestamps<T>;

    const keys = Object.keys(obj) as (keyof T)[];

    keys.forEach((key) => {
      const v = obj[key];

      if (
        typeof key === "string" &&
        (v as unknown) instanceof dayjs &&
        key.endsWith("_at")
      ) {
        newObj[key] = fn(v) as T[keyof T];
      } else {
        newObj[key] = v;
      }
    });

    return newObj;
  },
};
